// import { NOT_FOUND } from 'redux-first-router'
import { createAction } from '@reduxjs/toolkit';
import { LocationState } from 'redux-first-router';
import { FolderId, TDOId } from '../universal/models/Brands';

export const ROUTE_AUTH = createAction<any>('route/ROUTE_AUTH');
export const ROUTE_LOGOUT = createAction('route/ROUTE_LOGOUT');
// TODO: Fix the type here
export const ROUTE_HOME = createAction(
  'route/ROUTE_HOME',
  (payload?: { folderId: FolderId; isCase: boolean }) => ({
    payload,
  })
);
export const ROUTE_REDACTION_CODES = createAction(
  'route/ROUTE_REDACTION_CODES'
);
export const ROUTE_WATERMARKS = createAction('route/ROUTE_WATERMARKS');
export const ROUTE_INGEST = createAction('route/ROUTE_INGEST');
export const ROUTE_INGEST_GOVQA = createAction('route/ROUTE_INGEST_GOVQA');
export const ROUTE_EXAMPLE_TAKEOVER = createAction(
  'route/ROUTE_EXAMPLE_TAKEOVER'
);
export const ROUTE_EXAMPLE_TABS = createAction('route/ROUTE_EXAMPLE_TABS');
export const ROUTE_FORBIDDEN = createAction('route/ROUTE_FORBIDDEN');
export const ROUTE_MEDIA_DETAILS = createAction<{
  tdoId: TDOId;
  caseId?: string;
}>('route/ROUTE_MEDIA_DETAILS');
export const ROUTE_TRASH = createAction('route/ROUTE_TRASH');
// URL-only admin smoke check of Redact's data registries (runbook step).
export const ROUTE_ADMIN_DEPENDENCIES = createAction(
  'route/ROUTE_ADMIN_DEPENDENCIES'
);
export const ROUTE_FILE_IN_TRASH = createAction<{ tdoId?: string }>(
  'route/ROUTE_FILE_IN_TRASH'
);
export const ROUTE_DOCUMENT_DETAILS = createAction<{
  tdoId: TDOId;
  caseId?: string;
}>('route/ROUTE_DOCUMENT_DETAILS');
export const ROUTE_OVERVIEW = createAction('route/ROUTE_OVERVIEW');
export const ROUTE_LOAD_FAILED = createAction(
  'route/ROUTE_LOAD_FAILED',
  () => ({
    payload: undefined,
    query: {
      redirect: window.location.href,
    },
  })
);

export const ROUTE_ADD_MEDIA = createAction('route/ROUTE_ADD_MEDIA');
export const ROUTE_MEDIA_EDITOR = createAction('route/ROUTE_MEDIA_EDITOR');
export const ROUTE_REDACT_CASEDASHBOARD = createAction(
  'route/ROUTE_REDACT_CASEDASHBOARD'
);
export const ROUTE_SETTINGS_PROFILE = createAction(
  'route/ROUTE_SETTINGS_PROFILE'
);
export const ROUTE_DOCUMENT_REDACTION = createAction<{ tdoId: TDOId }>(
  'route/ROUTE_DOCUMENT_REDACTION'
);
export const ROUTE_REDACTION_STATUSES = createAction(
  'route/ROUTE_REDACTION_STATUSES'
);
export const ROUTE_LEXICONS = createAction('route/ROUTE_LEXICONS');

/**
 * Instance administration (VE-27257). Deliberately not in the side menu or the
 * app bar — a direct-URL utility for whoever installs Redact in an
 * environment, not a page the everyday user has a route to. `/admin` is a
 * landing page linking to the tools under it (`/admin/app-config`,
 * `/admin/dependencies`).
 */
export const ROUTE_ADMIN = createAction('route/ROUTE_ADMIN');
export const ROUTE_ADMIN_APP_CONFIG = createAction(
  'route/ROUTE_ADMIN_APP_CONFIG'
);
// export const refreshRoute = () => (dispatch, getState) => {
//   const currentLocation = getState().location;
//
//   dispatch({
//     type: currentLocation.type,
//     payload: currentLocation.payload,
//     meta: {
//       query: currentLocation.query
//     }
//   });
// };

export const ROUTE_KEYBOARD_SHORTCUTS = createAction(
  'route/ROUTE_KEYBOARD_SHORTCUTS'
);

/**
 * Routes that render standalone, static content with no auth requirement
 * (e.g. the popped-out keyboard-shortcuts legend). Boot skips the user
 * fetch / startup network calls for these and never redirects to login, so
 * the window loads fast and stays open even after the user logs out.
 */
export const PUBLIC_STANDALONE_ROUTE_TYPES: string[] = [
  ROUTE_KEYBOARD_SHORTCUTS.type,
];

interface WithLocation {
  location: LocationState<{
    requiresAuth: boolean;
    component: any;
    // Set per route in each app's routes map; read by RootRouter to decide whether the
    // shared app bar it owns is rendered above this route (VE-26729).
    showsAppBar?: boolean;
  }>;
}

export const selectCurrentRoutePayload = (state: WithLocation) =>
  state.location.payload;
export const selectRouteType = (state: WithLocation) => state.location.type;
export const selectRouteQuery = (state: WithLocation) => state.location.query;
export const selectRoutesMap = (state: WithLocation) =>
  state.location.routesMap;
export const selectPreviousRoute = (state: WithLocation) => state.location.prev;
export const selectPreviousRouteType = (state: WithLocation) =>
  state.location.prev.type;
